import type { IconSvgObject } from './types';

const GitBranchIcon: IconSvgObject = [
  ["path", { d: "M7 19.0234H16.5C17.6046 19.0234 18.5 18.128 18.5 17.0234V11.0234M21 12.5234L18.5 10.0234L16 12.5234", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 7.02344L5 17.0234", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "5", cy: "5.02344", r: "2", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M20.5 5.02344C20.5 6.12801 19.6046 7.02344 18.5 7.02344C17.3954 7.02344 16.5 6.12801 16.5 5.02344C16.5 3.91887 17.3954 3.02344 18.5 3.02344C19.6046 3.02344 20.5 3.91887 20.5 5.02344Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["circle", { cx: "5", cy: "19.0234", r: "2", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default GitBranchIcon;
